<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container h-100">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->

  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->

  <mat-sidenav-container
    class="example-sidenav-container"
    [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
  >
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav
      #snav
      id="snav"
      class="dark-sidebar pl-xs"
      [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0"
      [opened]="mobileQuery.matches"
      [disableClose]="!mobileQuery.matches"
    >
      <app-sidebar
        *ngIf="isMobile == true"
        [isMobileActive]="isMobile"
        (messageEvent)="receiveMessage($event)"
        (click)="snav.close()"
      ></app-sidebar>

      <app-sidebar *ngIf="isMobile == false"></app-sidebar>
    </mat-sidenav>

    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->

    <mat-sidenav-content class="page-wrapper">
      <app-header [title]="title"></app-header>
      <div class="chevron_style">
        <a
          style="cursor: pointer; margin-left: 5px"
          (click)="snav.toggle()"
          (click)="WindowResize($event)"
          value="sidebarclosed"
        >
          <div class="rotate">
            <img src="../../../assets/images/chevron_sidebar.svg" />
          </div>
          <!-- <div
            class="fa fa-chevron-right rotate"
            style="color: rgb(255, 255, 255)"
          ></div
        > -->
        </a>
      </div>

      <div class="page-content">
        <!-- <app-spinner *ngIf="isLoading = true"></app-spinner> -->
        <!-- <div class="row m-0 p-0 w-100 justify-content-between">
          <div class="row col-xs-1 align-items-center">
            <a
              style="cursor: pointer; margin-left: 5px"
              (click)="snav.toggle()"
              (click)="WindowResize($event)"
              value="sidebarclosed"
            >
              <div class="fa fa-chevron-right rotate" style="color: black"></div
            ></a>
          
          </div>
          <div class="col-xs-11 p-0 rightdiv">
            <div class="row">
              <span><h3 class="p_">Logout</h3></span>
              <i
                class="fas fa-sign-out signoutIcon position-relative ml-2 mt-2 mb-2"
                (click)="logoutUser()"
                style="cursor: pointer; font-size: 21px"
                mat-icon-button
              >
              </i>

              <mat-menu #profile="matMenu" class="mymegamenu">
                <button
                  *ngIf="
                    userRole == 'manager' ||
                    userRole == 'employee' ||
                    userRole == 'admin'
                  "
                  (click)="changePasswordNav()"
                  mat-menu-item
                >
                  <mat-icon [style.color]="'#0C479D'">no_encryption</mat-icon
                  >Change Password
                </button>
                <button (click)="logoutUser()" mat-menu-item>
                  <mat-icon [style.color]="'#0C479D'">exit_to_app</mat-icon>
                  Sign Out
                </button>
              </mat-menu>
            </div>
          </div>
        </div> -->
        <main>
          <router-outlet #page="outlet"></router-outlet>
        </main>

        <!-- <main>
                        <router-outlet #page="outlet"></router-outlet>
                      </main> -->
      </div>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>
